/* import __COLOCATED_TEMPLATE__ from './password.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { next } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
export let ScaPasswordError = /*#__PURE__*/function (ScaPasswordError) {
  ScaPasswordError["PASSWORD_PRESENCE"] = "PASSWORD_PRESENCE";
  ScaPasswordError["PASSWORD_TOO_SHORT"] = "PASSWORD_TOO_SHORT";
  return ScaPasswordError;
}({});
let TwoFactorScaPasswordComponent = (_class = class TwoFactorScaPasswordComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "password", _descriptor2, this);
    _initializerDefineProperty(this, "error", _descriptor3, this);
    _defineProperty(this, "handleInputLoaded", event => {
      next(() => event.detail.input.focus());
    });
    _defineProperty(this, "handleInputChange", event => {
      this.error = undefined;
      this.password = event.detail.value;
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      this.validatePassword();
      if (this.error) return;
      this.args.finish(this.password);
    });
  }
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get errorText() {
    if (!this.error) return '';
    switch (this.error) {
      case ScaPasswordError.PASSWORD_PRESENCE:
        return this.intl.t(`${this.tPrefix}two_factor_modals.sca.password.presence_error`);
      default:
        return this.intl.t(`${this.tPrefix}generic_errors.other.unknown`);
    }
  }
  validatePassword() {
    // Input hasn't been changed after last validation error. Keep the same error.
    if (this.error) return;
    if (this.password.length === 0) {
      this.error = ScaPasswordError.PASSWORD_PRESENCE;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "password", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TwoFactorScaPasswordComponent as default };